<template>
    <section id="pricing" class="section pricing-two bg-img">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-xl-6">
                    <div class="section__header wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                        <h2 class="h2">{{ labelsState['ready_to_start'] || '¿Ready to start?' }}</h2>
                        <h2 class="h2">{{ labelsState['start_today_free'] || 'Start today totally free' }}</h2>
                        <!--<h2 class="h2">{{ labelsState['find_plan'] || 'Find the plan that best suits your business' }}</h2>-->
                    </div>
                </div>
            </div>
            <div class="row items-gap">
                <!--Temporalmente se deja esta clase se debe borrar cuando se inicien los cobros-->
                <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
                    <div class="pricing-two__single wow fadeInUp" data-wow-duration="600ms" data-wow-delay="900ms">
                        <h5 class="h5 yel">{{ labelsState['free_beta'] || 'Free beta launch phase' }}</h5>
                        <div class="meta">
                            <div class="content">
                                <h2 class="h2 title">$0</h2>
                                <p>{{ labelsState['you_just_need_subscribe'] || 'You just need to subscribe' }}</p>                                
                            </div>
                        </div>
                        <hr>
                        <ul>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['use_free'] || 'Use all NQA services completely free of charge' }}</li>                         
                        </ul>
                        <hr>
                        <a href="https://dashboard.nqartificial.com/auth/cover-register" target="_blank" class="btn btn--septenary">{{ labelsState['free_demo'] || 'Free Demo' }}</a>
                    </div>
                </div>





                <!--<div class="col-12 col-md-6 col-lg-6 col-xxl-3">
                    <div class="pricing-two__single wow fadeInUp" data-wow-duration="600ms" data-wow-delay="600ms">
                        <h5 class="h5">{{ labelsState['basic'] || 'Basic' }}</h5>
                        <div class="meta">
                            <div class="content">
                                <h2 class="h2 title">$0</h2>
                                <p>{{ labelsState['free_demo'] || 'Free Demo' }}</p>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                            </div>
                        </div>
                        <hr>
                        <ul>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['team_member'] || 'a team member' }}</li>                            
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['gpt35'] || 'GPT 3.5' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['five_documents'] || 'Five Documents' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['a_robot'] || 'A Robot' }}</li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            
                            
                        </ul>
                        <hr>
                        <a href="https://forms.gle/V7B9o3a9VijyukVp7" target="_blank" class="btn btn--septenary">{{ labelsState['start_free'] || 'Start Free' }}</a>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
                    <div class="pricing-two__single wow fadeInUp" data-wow-duration="600ms" data-wow-delay="900ms">
                        <h5 class="h5 yel">{{ labelsState['standard'] || 'Standard' }}</h5>
                        <div class="meta">
                            <div class="content">
                                <h2 class="h2 title">$19.99</h2>
                                <p>{{ labelsState['monthly_payment'] || 'Payment per month' }}</p>
                                <h2 class="h2 title">$149.99</h2>
                                <p>{{ labelsState['yearly_payment'] || 'Payment per year' }}</p>
                            </div>
                        </div>
                        <hr>
                        <ul>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['team_members_three'] || 'three team members' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['credits_two_thousand_five'] || 'two thousand five hundred credits' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['gpt3516k'] || 'GPT 3.5 16K' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['five_hundred_documents'] || 'five hundred documents' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['three_robots'] || 'three robots' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['customize_chat'] || 'customize_chat' }}</li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            
                        </ul>
                        <hr>
                        <a href="https://forms.gle/V7B9o3a9VijyukVp7" target="_blank" class="btn btn--septenary">{{ labelsState['choose_plan'] || 'Choose plan' }}</a>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
                    <div class="pricing-two__single wow fadeInUp" data-wow-duration="600ms" data-wow-delay="900ms">
                        <h5 class="h5 pri">{{ labelsState['premium'] || 'Premium' }}</h5>
                        <div class="meta">
                            <div class="content">
                                <h2 class="h2 title">$29.99</h2>
                                <p>{{ labelsState['monthly_payment'] || 'Payment per month' }}</p>
                                <h2 class="h2 title">$249.99</h2>
                                <p>{{ labelsState['yearly_payment'] || 'Payment per year' }}</p>
                            </div>
                        </div>
                        <hr>
                        <ul>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['team_members_five'] || 'Five team members' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['creditsfivethousand'] || 'five thousand credits' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['gpt3516kGpt4'] || 'GPT 3.5 16K & GPT 4' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['thousand_documents'] || 'thousand documents' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['robots_five'] || 'five robots' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['customize_chat'] || 'customize_chat' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['remove_nqa_brand'] || 'Remove NQA flag from chat' }}</li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                            <li><i></i></li>
                        </ul>
                        <hr>
                        <a href="https://forms.gle/V7B9o3a9VijyukVp7" target="_blank" class="btn btn--septenary">{{ labelsState['choose_plan'] || 'Choose plan' }}</a>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 col-xxl-3">
                    <div class="pricing-two__single wow fadeInUp" data-wow-duration="600ms" data-wow-delay="1500ms">
                        <h5 class="h5 tri">{{ labelsState['expert'] || 'Expert' }}</h5>
                        <div class="meta">
                            <div class="content">
                                <h2 class="h2 title">$49.99</h2>
                                <p>{{ labelsState['monthly_payment'] || 'Payment per month' }}</p>
                                <h2 class="h2 title">$449.99</h2>
                                <p>{{ labelsState['yearly_payment'] || 'Payment per year' }}</p>
                            </div>
                        </div>
                        <hr>
                        <ul>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['team_members_fifteen'] || 'fifteen team members' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['twenty_thousand_credits'] || 'twenty thousand Credits' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['gpt3516kGpt4'] || 'GPT 3.5 16K & GPT 4' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['twenty_thousand_documents'] || 'twenty thousand Documents' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['fifteen_robots'] || 'fifteen robots' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['customize_chat'] || 'customize_chat' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['api'] || 'API' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['remove_nqa_brand'] || 'Remove NQA flag from chat' }}</li>
                            <li><i class="fa-solid fa-check"></i>{{ labelsState['personalized_advice'] || 'Personalized advice' }}</li>
                        </ul>
                        <hr>
                        <a href="https://forms.gle/V7B9o3a9VijyukVp7" target="_blank" class="btn btn--septenary">{{ labelsState['choose_plan'] || 'Choose plan' }}</a>
                    </div>
                </div>-->
            </div>
        </div>
    </section>
</template>

<script>
import { useLabelsStore } from '@/stores/labels';
import { useLanguageStore } from '@/stores/language';
import { computed, onMounted } from 'vue';
import axios from 'axios';

export default {
    name: "Pricing",
    setup() {
        const labelsStore = useLabelsStore();
        const languageStore = useLanguageStore();

        const changeLanguage = (languageCode) => {
            labelsStore.fetchAndSetLabels(languageCode);
        };

        const labelsState = computed(() => labelsStore.labels);
        const languageCodes = computed(() => languageStore.codes);

        return {
            labelsState,
            languageCodes,
            changeLanguage,
        };
    },
};
</script>

<style>
.pricing-two {
    background-color: #111827;
}
</style>



// WEBPACK FOOTER //
// src/components/page_components/home-2/Pricing.vue